module.exports = __webpack_public_path__ + "static/media/2-9.38a5e0ad.mp3";